
// Keycloak / OIDC client configuration used by the frontend when redirecting
/* export const env = {
    production: false,
    apiUrl: 'http://localhost:2000/v0.1/api/simo/',
    filesBaseUrl: 'http://localhost:2000'
} */

export const keycloakConfig = {
  //baseUrl: 'http://localhost:8081', // Keycloak base URL dev (no trailing slash)
  baseUrl: 'https://auths.moderneticbenin.com', // Keycloak base URL prod (no trailing slash)
  //realm: 'ceb-realm', // dev
  realm: 'CEB-REALM-PROD',//prod
  clientId: 'frontend-ceb',
  responseType: 'code',
  scope: 'openid profile email'
};


// Production configuration (example)
export const env = {
  production: true,
  apiUrl: 'https://backend.fga-samb.moderneticbenin.com/v0.1/api/simo/',
  filesBaseUrl: 'https://backend.fga-samb.moderneticbenin.com'
  //vien du main apiUrl: 'https://backend.ceb.moderneticbenin.com/v0.1/api/simo/'
};
